export default __webpack_public_path__ + "static/media/chowbusLogoText.9bdb929b.png";